import { Alert } from '@mui/material';
import React, { ErrorInfo } from 'react';

export default class ErrorBoundary extends React.Component<
  { errorText?: string; onError?: () => void },
  { hasError: boolean }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.props.onError?.();
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Alert severity="error" sx={{ mt: 2 }}>
          {this.props.errorText || 'Något gick fel'}
        </Alert>
      );
    }

    return this.props.children;
  }
}
